/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoTwitterIcon24Regular = forwardRef('LogoTwitterIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.317 4.24a.75.75 0 1 0-1.135-.98l-5.246 6.074-4.451-5.887A1.125 1.125 0 0 0 7.588 3H4.504a1.125 1.125 0 0 0-.898 1.804l6.182 8.176-5.856 6.78a.75.75 0 1 0 1.135.98l5.646-6.537 4.802 6.35c.212.282.544.447.897.447h3.084c.93 0 1.458-1.062.898-1.803l-6.532-8.64 5.455-6.317ZM16.6 19.5 5.257 4.5h2.144l11.341 15H16.6Z" })));
});
